import { useEffect, useState } from "react";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _Inbox, _single } from "../../../core/services/dataBean/EntityCatalog";
import { env } from "../../../env";
import { ModalGeneric } from "../../../interfaces";
import { Modal } from "../../theme/Component/Modal";
import { BPMProcedureAction } from "./BPMProcedureAction";
import { HandlerInfoProcess } from "../config/InfoTramiteComponents/HandlerInfoProcess";
import { toast } from "react-toastify";
import { BasicButton } from "../../theme/Component/BasicButton";
import usePaginator from "../../theme/Component/usePaginator";

export const BPMInboxAssigned = () => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_Inbox);
    const [obs, setObs] = useState<string>("")
    const [filter,setFilter] = useState<any>({
        
    });

    const [modalProcess, setModalProcess] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalHistory, setModalHistory] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalCancel, setModalCancel] = useState<ModalGeneric>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const paginador = usePaginator();

    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
       

        instance.getProcedureImpForResponseReport(_single.getAccountID(),paginador.page,15,_single.cleanMap(filter)).then(
            (resp) => {
                
                 paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                let temp = resp.List;
                temp.forEach(element => {
                    element.DataBeanProperties.AccountInfo = renderUserInfo(element);  
                });
                setLista(temp);

            }
        )
    }

    const deleteProcedureImp = () => {
        instance.cancelProcedureImp(bean.IDProcedureImp, _single.getAccountID(), obs).then(
            (resp: any) => {
                toast.success("Se ha realizado la accion");
                getLista();
                pushResumeInfo(obs)
                setModalCancel({ ...modalCancel, "view": false });
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("No se pudo realizar la acción")
            }
        )
    }

    const pushResumeInfo = (objeto: any) => {
        instance.pushResumeBpm(bean.IDProcedureImp, _single.getAccountID(), `${objeto} - Paso de Cancelación: ${bean.ProcedureStep}`, { disableSpinner: true }).then(
            (resp) => {
                setObs("");
            }
        ).catch(err => { console.log("Error en actualizar la tabla", err) })
    }

    const renderUserInfo = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.DataBeanProperties.AccountID ? item.DataBeanProperties.AccountID : 'NA'}</small><br />
            <strong>Usuario: </strong><small>${item.DataBeanProperties.AccountName ? item.DataBeanProperties.AccountName : 'NA'}</small><br />            
        </div>
        `
        return render;
    }

    const head = [
        { title: 'Codigo', property: 'AlphaCode', visible: true },
        { title: 'Procedimiento', property: 'BusinessProcessName', visible: true },
        { title: 'Solicitud', property: 'Description', visible: true },
        { title: 'Paso actual', property: 'ProcedureName', visible: true },
        { title: 'Solicitante', property: 'AccountInfo', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Fecha de Asignacion', property: 'AssignmentDate', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Historico', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalHistory({ ...modalHistory, "view": true, "name": "Historico del Procedimiento" }) } },
            { titulo: 'Gestionar Proceso', icono: 'ri-user-follow-line', visible: true, evento: () => { setModalProcess({ ...modalProcess, "view": true, "name": "Actividades Pendientes" }) } },
            { titulo: 'Cancelar Tramite', icono: 'ri-close-circle-line', visible: true, evento: () => { setModalCancel({ ...modalCancel, "view": true, "name": "Confirmar Cancelación del tramite" }); setObs("") } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <div className="row">
            <div className="col-md-6">
                <label>Buscar Solicitud</label>
                <input type="text" name="Desc" className="form-control" value={filter.Description} onChange={(e)=>{setFilter({...filter,"Description":e.target.value})}} />
            </div>
            <div className="col-md-6">
                <BasicButton useMargin icon="" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} records={paginador} />
            </div>


            <div className="col-md-12">
                <div className="col-md-12">
                    <Modal modal={modalHistory} updateModal={setModalHistory} >
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureImp} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalProcess} updateModal={setModalProcess} >
                        <BPMProcedureAction requestLista={() => { getLista(); setModalProcess({ ...modalProcess, "view": false }); }} Procedure={bean} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalCancel} updateModal={setModalCancel} eventModal={() => { deleteProcedureImp() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <textarea rows={5} className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>
    )
}